// @vendors
const Immutable = require('immutable');

// @constants
const {
    CARDS_CANCEL_PAY_LATER_VALIDATE_STEP,
} = require('constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    valid: false
});

function cardsCancelPayLaterStep1Reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CARDS_CANCEL_PAY_LATER_VALIDATE_STEP:
            return state.set('valid', true);
        default:
            return state;
    }
}

module.exports = cardsCancelPayLaterStep1Reducer;